// extracted by mini-css-extract-plugin
export default {"changeLocationWrapper":"ChangeLocationAssistent_changeLocationWrapper__-h74+","changeLocationItem":"ChangeLocationAssistent_changeLocationItem__kqCwX"};